import { CatalogueActionLogTable } from 'components/catalogueAction'
import { Helmet } from 'react-helmet'

const CatalogueActionLog = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | CatalogueAction Logs </title>
      </Helmet>
      <CatalogueActionLogTable />
    </>
  )
}

export default CatalogueActionLog
